import { defineMessages } from 'react-intl';

export default defineMessages({
  addNote: {
    defaultMessage: 'Add Note',
    description: 'returnNotes.addNote',
    id: 'kDhF03',
  },
});
